import axios from './axios';

const API_URL = '/C4-Nicaragua/Series'; // ajusta si usas otro endpoint"el nombre del archivo de route de backend 

export const getSeries = async () => {
  try {
    const response = await axios.get(API_URL);
    return response.data;
  } catch (error) {
    console.error('Error al obtener Series:', error);
    return [];
  }
};

export const addSerie = async (serie) => {
  try {
    const response = await axios.post(API_URL, serie);
    return response.data;
  } catch (error) {
    console.error('Error al guardar serie', error);
    throw error;
  }
};

export const updateSerie = async (id, serie) => {
  try {
    const response = await axios.put(`${API_URL}/${id}`, serie);
    return response.data;
  } catch (error) {
    console.error('Error al actualizar serie', error);
    throw error;
  }
};

export const eliminarSerie  = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error al eliminar serie', error);
    throw error;
  }
};
